import * as React from 'react';

function SvgIconProperties(props) {
  return (
    <svg viewBox="0 0 23 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 9.5h5v9h-5v-9zM15.5 8a1 1 0 00-1 1v10a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1h-6zm-14-6.5v17h10v-17h-10zM1 0h11a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z" />
      <path d="M3.5 4h2.25v2.25H3.5zm3.75 0H9.5v2.25H7.25zM3.5 8h2.25v2.25H3.5zm3.75 0H9.5v2.25H7.25z" />
    </svg>
  );
}

export default SvgIconProperties;
